// Home hero section scaffold (primary headline + CTA area).
import PageHero from "../../../components/layout/PageHero";
import { useLanguage } from "../../../i18n/LanguageContext";

export default function HomeHero() {
  const { t, lang  } = useLanguage(); 
  const slides = t.home.heroSlides;
  return (
    <>
      {/*Hero section with auto-sliding text and a static image */}
      <PageHero showSlider={true} slides={slides} showImage={true} isRTL={lang  === "ar"} />
    </>
  );
}
